export { default } from './Captcha';
